module.exports = __webpack_public_path__ + "static/media/S (102).ce797298.jpg";